import {useEffect, useReducer, useState } from "react";
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',
    SET_INITIAL_DATA: 'set-data',
    SET_INITIAL_CHECK_DATA: 'set-check-data',
    
    RADIO_CHANGE: 'radio-change',
    RADIO_SET_ERRORS: 'radio-set-errors',
    RADIO_REMOVE_ERRORS: 'radio-remove-errors',

    CHECK_CHANGE: 'check-change',
    CHECK_SET_ERRORS: 'check-set-errors',
    CHECK_REMOVE_ERRORS: 'check-remove-errors',

};

const RoleDataReducer = (state, action) => {
    //console.log("dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                data: action.data,
                loading: action.loading
            };
        }

        case ACTIONS.SET_INITIAL_CHECK_DATA: {
            return action.data;
        }
        
        case ACTIONS.RADIO_CHANGE: {
            //console.log("state-RADIO_CHANGE");
            //console.log(state);

            //const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            /*
            type: 'radio',
                name: "roleId",
                value: 10000,
                validation: {
                    required: true,
                    isInvalid: false, //REPLACE
                    errors: []
                },
                //disabled: getVarValue(disabled),
                //readOnly: getVarValue(readOnly),
                //hideFieldOrgTypes: hideFieldOrgTypes,
                InputRef: useRef(null)
            */
            return {
                ...state,
                value: action.value,
                validation: {
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
        
        case ACTIONS.CHECK_CHANGE: {
            //console.log("state");
            //console.log(state);

            //const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action);

            return {
                ...state,
                [action.name]: action.checked
            };
        }


        case ACTIONS.RADIO_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            //const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            /*
            type: 'radio',
                name: "roleId",
                value: 10000,
                validation: {
                    required: true,
                    isInvalid: false, //REPLACE
                    errors: []
                },
                //disabled: getVarValue(disabled),
                //readOnly: getVarValue(readOnly),
                //hideFieldOrgTypes: hideFieldOrgTypes,
                InputRef: useRef(null)
            */
            return {
                ...state,
                //value: action.value
                validation: {
                    ...state.validation,
                    isInvalid: true,
                    errors: action.errors
                }
            };
            /*//console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };*/
        }
        case ACTIONS.RADIO_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.radioButtons);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
        
       

        case ACTIONS.CHECK_SET_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: action.errors != null ? true : false,//isInvalidFunc(path.validation.required,action.value),
                            errors: action.errors
                        }

                    }
                }
            };
        }
        case ACTIONS.CHECK_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);

            const path = state.data[action.name];
            //console.log(path.checkBoxes);
            //console.log(action.name);

            return {
                ...state,
                data: {
                    ...state.data,
                    [action.name]: {
                        ...path,
                        
                        validation:{
                            ...path.validation,
                            isInvalid: false,
                            errors: []
                        }

                    }
                }
            };
        }
    }
}







export {ACTIONS, RoleDataReducer};